
define('text!responsive-gameday-calendar/src/templates/gd_calendar.tpl',[],function () { return '<div id="scoreboardDisplayDate">\n\t<span class="left"></span>\n\t<span class="js-clickable-calendar">\n\t\t<span class="icon"></span>\n\t\t<span class="gdate">{{ date }}</span>\n\t</span>\n\t<span class="right"></span>\n</div>';});

